import { useQuery } from '@tanstack/react-query';
import { USER_ROLES_CACHE_KEY } from '@/consts/api';
import { useDebouncedValue } from '@/hooks/useDebounceValue';
import { useFetch } from '@/hooks/useFetch';
import type { GetUserRolesResponse } from '@/types/userApiTypes';
import { getUserRolesUrl } from './utils/getUserRolesUrl';

export const useGetUserRoles = (search?: string | null, page?: string | number) => {
  const { doFetch } = useFetch<void, GetUserRolesResponse>();
  const debouncedSearch = useDebouncedValue(search, 500);

  return useQuery({
    queryKey: [USER_ROLES_CACHE_KEY, debouncedSearch, page],
    queryFn: () => doFetch(getUserRolesUrl({ search: debouncedSearch, page })),
  });
};